export default __webpack_public_path__ + "static/media/voting.ba4176ab.svg";